module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 205 64",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }